// extracted by mini-css-extract-plugin
module.exports = {"box":"Eliag","title":"-uhWY","desc":"_3JTEM","controls":"_2r_YB","button":"_30nJE","agreeButton":"jhW1w","header":"_3OJLL","body":"_3Yl3W"};